import React, { Fragment } from 'react'
import { arrayOf, string, shape } from 'prop-types'
import ThemeConsumer from '../ThemeConsumer'
import Link from '../Link'
import { List } from './index'


const Summary = ({
  theme,
  items,
  anchorText,
  anchorUrl,
}) => (
  <Fragment>
    <List items={items} />
    <div className={theme.anchor}>
      <Link to={anchorUrl} callToAction>{anchorText}</Link>
    </div>
  </Fragment>
)

Summary.propTypes = {
  items: arrayOf(string),
  anchorUrl: string.isRequired,
  anchorText: string.isRequired,
  theme: shape({
    anchor: string,
  }),
}

Summary.defaultProps = {
  theme: {},
  items: [],
}

export default ThemeConsumer('UISummary')(Summary)



// WEBPACK FOOTER //
// ./src/shared/components/List/Summary.js